module.exports = __webpack_public_path__ + "static/img/wx2.9ca555e0.png";